import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { CircularProgress } from '@material-ui/core';

import logo from '../../assets/img/logo-full.png';
import '../../assets/css/login.css';

import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

import { useDispatch, useSelector } from 'react-redux';
import * as authActions from '../../store/actions/authActions';
import { Fragment } from 'react';
import AlertError from './AlertError';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [open, setOpen] = useState(false);
    const [isLoading, SetIsLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const userProfile = useSelector(state => state.profile.userProfile);

    const dispatch = useDispatch();

    const history = useHistory();

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpen(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        SetIsLoading(true);
        dispatch(authActions.authForgotPassword(email, password))
            .then(() => {
                setOpen(true);
            })
            .then(() => {
                history.push('/account/login');
            })
            .catch(() => {
                SetIsLoading(false);
                setShowError(true);
                setErrorMessage('Invalid Password Entered');
            });
    };

    const renderButtons = () => {
        return (
            <Fragment>
                <button name="login" id="login" className="welcome-btn" type="submit">Change Password</button>
            </Fragment>
        );
    }

    return (
        <div className="main-container">
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success">
                    New Password Successfully Set!
                </Alert>
            </Snackbar>
            <div className="welcome-container">

                <img className="welcome-logo" src={logo} />

                <h2 className="welcome-title">Welcome Back</h2>

                <div className="welcome-form">
                    {showError ? <AlertError message={errorMessage} /> : null}

                    <form onSubmit={handleSubmit}>
                        <input 
                            type="email" 
                            name="email"
                            id="email" 
                            className="welcome-field" 
                            placeholder="Email Address"
                            onChange={e => setEmail(e.target.value)} />

                        <label htmlFor="email">Password must be 8 characters</label>
                        <input 
                            type="password" 
                            name="password" 
                            id="password" 
                            className="welcome-field" 
                            placeholder="New Password"
                            onChange={e => setPassword(e.target.value)} />
                        
                        {isLoading ? <CircularProgress /> : renderButtons()}
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;
